import { computed, ref } from "vue";
import MovementCategory from "@shared-models/movement/movement.category.model";

/**
 * Filtre multi-sélection des familles matériel (racines de MovementCategory), partagé entre la carte
 * « Diversité » (arcs cliquables du donut) et la modal des filtres — même mécanique que `useWorkoutTypesFilter`
 * côté types.
 *
 * Le ref est module-scope (singleton) → cliquer une famille dans le donut met à jour la modal des filtres et
 * le badge du bouton, sans store intermédiaire. On stocke les OBJETS catégories (pas juste les alias) pour
 * pouvoir réafficher les badges dans la modal sans re-fetch. Filtre purement client (dim + recalcul), pas
 * d'appel API → pas de persistance URL.
 */

const selectedCategories = ref<MovementCategory[]>([]);

export default function useMovementCategoryFilter()
{
	const selectedAliases = computed<string[]>(() =>
		selectedCategories.value.map(c => c.alias ?? "").filter(Boolean));

	const isSelected = (alias: string | null | undefined): boolean =>
		!! alias && selectedCategories.value.some(c => c.alias === alias);

	const toggle = (category: MovementCategory): void =>
	{
		const alias = category.alias;
		if (! alias)
		{
			return;
		}
		selectedCategories.value = isSelected(alias)
			? selectedCategories.value.filter(c => c.alias !== alias)
			: [ ...selectedCategories.value, category ];
	};

	const clear = (): void => { selectedCategories.value = []; };

	return { selectedAliases, isSelected, toggle, clear };
}
